<script setup lang="ts">
import { inject } from 'vue'
import CheckListItem from './CheckListItem.vue'

interface Props {
  /** Checklist items */
  items?: string[]
  /** Icon to display */
  icon?: string
  /** Icon color */
  color?: string
}

const { items = [], icon = undefined, color = undefined } = defineProps<Props>()

defineOptions({
  name: 'CheckList'
})

const isMobileApp = inject('isMobileApp', false)
</script>

<template>
  <ul class="flex flex-col" :class="isMobileApp ? 'gap-1' : 'gap-2'">
    <slot :items>
      <template v-for="(item, key) in items" :key>
        <slot name="item" :item>
          <CheckListItem :item :icon :color />
        </slot>
      </template>
    </slot>
  </ul>
</template>
